// extracted by mini-css-extract-plugin
export default {"dashboardCardWrapper":"AnalystReportsStyle_dashboardCardWrapper__u3vQ-"};